<template>

  <el-row :gutter="5">
    <el-col :span="6"></el-col>
    <el-col :span="12"><h2 class="heading">My Interview (Media) List</h2></el-col>
    <el-col :span="6" style="padding-top:20px;">
        <el-button v-if="global.hasRight('event-interview', 'approver') || global.hasRight('event-interview', 'admin')" 
            @click="$router.push('/log/allInterviewList')">
            <el-icon><Search/></el-icon> &nbsp; All Interview List</el-button>
        <el-button style="margin-left:20px;" @click="$router.push('/log/editInterview')" >
            <el-icon><Plus/></el-icon> &nbsp; Add Interview</el-button>
    </el-col>
  </el-row>

  <el-table :data="interviewList" height="88%" style="width:95%; margin:15px auto;" :row-class-name="tableRowClassName"
        :default-sort="{ prop: prop, order: order }" @sort-change="sortChange">
    <el-table-column prop="activityDate" label="Activity date" align="center" width="130" sortable="custom" />
    <el-table-column prop="mediaName" label="Media name" width="200" sortable="custom"/>
    <el-table-column prop="type" label="Nature" width="160" sortable="custom"/>
    <el-table-column prop="city" label="City" sortable="custom" />
    <el-table-column prop="externalLead" label="External lead" width="200" sortable="custom" />
    <el-table-column prop="interviewer" label="Interviewer" sortable="custom" width="180"/>
    <el-table-column prop="interviewee" label="Interviewee" sortable="custom" width="120"/>
    <el-table-column prop="pubDate" label="Publish date" width="130" sortable="custom" />
    <el-table-column prop="creatorName" label="Creator" sortable="custom" />
    <el-table-column prop="status" label="Status" sortable="custom" />
    <el-table-column prop="status" label="Action" align="center">
        <template #default="scope">
            <a href="" v-if="scope.row.status=='pending' && global.hasRight('event-interview', 'approver')" 
                @click.prevent="$router.push('/log/viewInterview?code=' + scope.row.idMD5)" title="Approve" class="op">
                Approve
            </a>
            <el-icon v-else :size="16" @click="$router.push('/log/viewInterview?code=' + scope.row.idMD5)" style="cursor:pointer" 
                title="View details" class="op">
                <document />
            </el-icon>
            <el-icon :size="16" v-if="(scope.row.status=='pending'||scope.row.status=='rejected') && currentUser.id == scope.row.creator" 
                @click.prevent="$router.push('/log/editInterview?code=' + scope.row.idMD5)" title="Edit" class="op">
                <Edit/>
            </el-icon>
            <el-icon :size="16" v-if="scope.row.status=='pending' && currentUser.id == scope.row.creator" 
                @click="deleteInterview(scope.row.idMD5)" title="Delete"  class="op">
                <Delete />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>
  <el-pagination background layout="prev, pager, next" :total="page.rowCount" :page-size="page.pageSize" :currentPage="page.currPage"
    @current-change="getInterviewList" style="justify-content: center;"></el-pagination>

</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Document, Search, Plus, Delete, Edit } from '@element-plus/icons-vue'

export default {
    components: {
        Document,  Search, Plus, Delete, Edit
    },
    data() {
        return {
            orderObj : {prop: "id", order: "descending"},
            currentUser: null,
            interviewList: [],
            page: {currPage: 1},
            errMsg: '',
            global,
        }
    },
    async mounted() {
        this.global.index = "interview";
        this.currentUser = this.global.currentUser;
        this.getInterviewList(1);
    },
    methods: {
        async getInterviewList(pageNo) {
            this.page.currPage = pageNo;
            let data = {pageNo: pageNo};
            if (this.orderObj.prop) {
                data["prop"] = this.orderObj.prop;
                data["order"] = this.orderObj.order;
            }
            let result = await AXIOS("/log/myInterviewList", data);
            if (result.success) {
                this.interviewList = result.data.list;
                this.page = result.data.page;
            } else {
                this.errMsg = result.errMsg;
            }
        },
        sortChange(orderObj) {
            this.orderObj = orderObj;
            this.getInterviewList(1);
        },
        tableRowClassName(scope) {
            return (scope.row.status == "approved" || scope.row.status == "rejected") ? "" : scope.row.status;
        },
        deleteInterview(code) {
            ElMessageBox.confirm(
                'Are you sure want to delete this interview?',  'Warning', {
                    confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning',
                }
            ).then(async () => {
                let result = await AXIOS("/log/deleteInterview", {code : code});
                if (result.success) {
                    this.interviewList.splice(this.interviewList.findIndex(e => e.idMD5 == code), 1);
                    ElMessage({
                        message: 'Deleted interview successfully!', type: 'success',
                    });
                } else {
                    ElMessage({
                        message: result.errMsg, type: 'error',
                    });
                }
            });
        }
    }
}
</script>

<style>
    .errMsg {
        padding-left:20px;
    }
    .successMsg {
        padding-left:20px;
    }
</style>